import { createClient, Host } from '@wix/sdk';
import { reactElements, info } from '@wix/editor';
import { DefaultClient } from '../types';

export const createDefaultClient = (host: Host): DefaultClient => {
  return createClient({
    host,
    modules: { element: reactElements, reactElements, info },
  }) as DefaultClient;
};
